"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.register = register;
exports.updateQDPresence = updateQDPresence;
exports.getChannelName = getChannelName;
exports.subscribeQDPresence = subscribeQDPresence;
exports.unregister = unregister;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _MessagingService = _interopRequireDefault(require("../MessagingService"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var _EquizzerActions = _interopRequireDefault(require("../../../common/components/Equizzer/actions/EquizzerActions"));

var _DataStore = _interopRequireDefault(require("../../../KESI2/Stores/DataStore2"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var DATA_CHANNEL = 'private:equeoqd:'; // ensure instance id is generated
// RegisterInstance.init()
// init channel
// messageService.getChannel(DATA_CHANNEL)

function updatePresenceList(_x) {
  return _updatePresenceList.apply(this, arguments);
}

function _updatePresenceList() {
  _updatePresenceList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(channelName) {
    var presentUsers, presencesByNickname;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _MessagingService["default"].getPresence(channelName);

          case 2:
            presentUsers = _context.sent;
            presencesByNickname = presentUsers.reduce(function (acc, val) {
              acc[val.data.nickname] = val.data;
              return acc;
            }, {});

            _EquizzerActions["default"].setUserPresences(presencesByNickname);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updatePresenceList.apply(this, arguments);
}

var listeners = {};
var lastInvisibleValue = null;

function register(onDataReceivedCallback, groupId, nickname) {
  _RegisterInstance["default"].init();

  var channelName = "".concat(DATA_CHANNEL).concat(groupId);

  _MessagingService["default"].registerChannel(channelName, onDataReceivedCallback);

  listeners[groupId] = _DataStore["default"].addOnChangeListener(function () {
    var isInvisible = _DataStore["default"].getElementByPathImmediately('public.equeoqd.onlineVisibility') === false;

    if (lastInvisibleValue !== isInvisible) {
      lastInvisibleValue = isInvisible;

      _MessagingService["default"].updatePresence(channelName, {
        nickname: nickname,
        showOnlineState: !isInvisible
      });
    }
  });
  var isInvisible = _DataStore["default"].getElementByPathImmediately('public.equeoqd.onlineVisibility') === false;
  console.log('enterPresence with showOnlineState: ', !isInvisible);

  _MessagingService["default"].enterPresence(channelName, {
    nickname: nickname,
    showOnlineState: !isInvisible
  });

  _MessagingService["default"].subscribePresence(channelName, function () {
    return updatePresenceList(channelName);
  });

  updatePresenceList(channelName);
}

function updateQDPresence(nickname, groupId, additionalData) {
  var channelName = "".concat(DATA_CHANNEL).concat(groupId);
  var isInvisible = _DataStore["default"].getElementByPathImmediately('public.equeoqd.onlineVisibility') === false;
  var data = {
    nickname: nickname,
    showOnlineState: !isInvisible
  };

  var mergedData = _objectSpread(_objectSpread({}, additionalData), data);

  _MessagingService["default"].updatePresence(channelName, mergedData);
}

function getChannelName(groupId) {
  return "".concat(DATA_CHANNEL).concat(groupId);
}

function subscribeQDPresence(groupId, callback) {
  var channelName = "".concat(DATA_CHANNEL).concat(groupId);

  _MessagingService["default"].subscribePresence(channelName, callback);
}

function unregister(onDataReceivedCallback, groupId) {
  var channelName = "".concat(DATA_CHANNEL).concat(groupId);

  if (listeners[groupId]) {
    listeners[groupId]();
  }

  _MessagingService["default"].leavePresence(channelName);

  _MessagingService["default"].unregisterChannel(channelName, onDataReceivedCallback);

  _MessagingService["default"].unsubscribePresence(channelName);
}